import { SSO } from "../../common/apiUrl/sso/ssoUrl";
import { BatchJsonRequestBody, OrganizerCommonJsonRequestBody, ProformaJsonRequestBody, ResendAccessLinkJsonRequestBody, SendReminderJsonRequestBody, UpdateDocumentStatusJsonRequestBody } from "../../common/model/sso/jsonRequest";
import { generateCallbackCurlCommand, generateCurlCommand, generateNoBodyCurlCommand } from "../helperFunctions";

const organizerCommonJsonRequestBody: OrganizerCommonJsonRequestBody = {
  organizerId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string"
}

const batchJsonRequestBody: BatchJsonRequestBody = {
  csvFileUri: "string",
  zipFileUri: "string",
  batchName: "string",
  ero: "0",
  taxYear: "0",
  taxSoftware: "0",
  enableEngagementLetter: "true",
  callbackUri: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  locationId: "0"
}

const sendReminderRequestBody: SendReminderJsonRequestBody = {
  organizerId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  engagementLetterReminder: false,
  organizerReminder: false,
  sourceDocumentReminder: false
}

const proformaJsonRequestBody: ProformaJsonRequestBody = {
  clientId: "string",
  eroUser: 0,
  taxYear: 0,
  taxSoftware: 0,
  taxReturnType: 0,
  callbackUri: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  organizer: {
    document: "string",
    fileUrl: "string",
    fileName: "string"
  },
  engagementLetter: {
    document: "string",
    fileUrl: "string",
    fileName: "string"
  },
  isEngagementLetterIncluded: true
}

const updateDocumentStatusJsonRequestBody: UpdateDocumentStatusJsonRequestBody = {
  documentGuid: "string",
  fileNames: [
    "string"
  ],
  documentType: 0
}

const resendAccessLinkJsonRequestBody: ResendAccessLinkJsonRequestBody = {
  organizerId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  signerGuid: "string"
}

export const batchJsonRequestCurl = generateCallbackCurlCommand(
  SSO.UPLOAD.BATCH_URL,
  "POST",
  batchJsonRequestBody
);


export const proformaJsonRequestCurl = generateCallbackCurlCommand(
  SSO.UPLOAD.PROFORMA_URL,
  "POST",
  proformaJsonRequestBody
);

export const archivedOrganizerJsonRequestCurl = generateNoBodyCurlCommand(
  SSO.ARCHIVED.ARCHIVED_ORGANIZERS_URL,
  "GET",
);

export const deleteOrganizerJsonRequestCurl = generateCallbackCurlCommand(
  SSO.ARCHIVED.DELETE_ORGANIZERS_URL,
  "DEL",
  organizerCommonJsonRequestBody
);

export const moveToDeliveredJsonRequestCurl = generateCallbackCurlCommand(
  SSO.ARCHIVED.MOVE_TO_DELIVERED,
  "PUT",
  organizerCommonJsonRequestBody
);

export const resendAccessLinkJsonRequestCurl = generateCurlCommand(
  SSO.ARCHIVED.RESEND_ACCESS_LINK,
  "POST",
  resendAccessLinkJsonRequestBody
);

export const signerDetailsJsonRequestCurl = generateNoBodyCurlCommand(
  SSO.ARCHIVED.SIGNER_DETAILS,
  "GET",
);

export const archiveOrganizerDeliveredJsonRequestCurl = generateCallbackCurlCommand(
  SSO.DELIVERED.ARCHIVE_ORGANIZER_URL,
  "PUT",
  organizerCommonJsonRequestBody
);

export const deleteOrganizerDeliveredJsonRequestCurl = generateCallbackCurlCommand(
  SSO.DELIVERED.DELETE_ORGANIZER_URL,
  "DEL",
  organizerCommonJsonRequestBody
);

export const deliveredOrganizerJsonRequestCurl = generateNoBodyCurlCommand(
  SSO.DELIVERED.DELIVERED_ORGANIZER_URL,
  "GET",
);

export const deliveredResendAccessLinkJsonRequestCurl = generateCurlCommand(
  SSO.DELIVERED.RESEND_ACCESS_LINK_URL,
  "POST",
  resendAccessLinkJsonRequestBody,
);

export const sendReminderLinkJsonRequestCurl = generateCurlCommand(
  SSO.DELIVERED.SEND_REMINDER_URL,
  "POST",
  sendReminderRequestBody,
);

export const deliveredSignerDetailsJsonRequestCurl = generateNoBodyCurlCommand(
  SSO.DELIVERED.SIGNER_DETAILS_URL,
  "GET",
);

export const deleteInProcessOrganizerJsonRequestCurl = generateCallbackCurlCommand(
  SSO.IN_PROCESS.DELETE_IN_PROCESS_ORGANIZER_URL,
  "DEl",
  organizerCommonJsonRequestBody,
);

export const inProcessOrganizersJsonRequestCurl = generateNoBodyCurlCommand(
  SSO.IN_PROCESS.IN_PROCESS_ORGANIZERS_URL,
  "GET",
);

export const deleteRecycleBinOrganizerJsonRequestCurl = generateCallbackCurlCommand(
  SSO.RECYCLE_BIN.DELETE_RECYCLE_BIN_ORGANIZER_URL,
  "DEl",
  organizerCommonJsonRequestBody,
);

export const restoreRecycleBinOrganizerJsonRequestCurl = generateCallbackCurlCommand(
  SSO.RECYCLE_BIN.RESTORE_RECYCLE_BIN_ORGANIZER_URL,
  "PUT",
  organizerCommonJsonRequestBody,
);

export const recycleBinOrganizerJsonRequestCurl = generateNoBodyCurlCommand(
  SSO.RECYCLE_BIN.RECYCLE_BIN_ORGANIZER_URL,
  "GET",
);

export const organizerStatusJsonRequestCurl = generateNoBodyCurlCommand(
  SSO.ORGANIZER_STATUS.GET_ORGANIZER_STATUS_URL,
  "GET",
);

export const updateDocumentStatusJsonRequestCurl = generateCurlCommand(
  SSO.ORGANIZER_STATUS.UPDATE_DOCUMENT_STATUS_URL,
  "PUT",
  updateDocumentStatusJsonRequestBody,
);